import React, {FC} from 'react';
import styled from 'styled-components';

import {fontSizes} from '../../../../libs/shared/ui/src/styles/fontStyles';

/*
 * Props.
 */

interface TableEmptyStateProps {
  // Height of your header items
  headerOffset: number;

  className?: string;
}

interface EmptyStateContainerProps {
  $top: number;
}

/*
 * Style.
 */

const StyledEmptyStateContainerDiv = styled.div<EmptyStateContainerProps>`
  position: absolute;
  top: ${(p) => p.$top}px;
  left: 0;
  right: 0;
  overflow: hidden;

  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledEmptyStateContentsContainerDiv = styled.div`
  display: flex;
  flex-flow: column;
  text-align: center;
`;

const StyledEmptyStateDescriptionDiv = styled.div`
  max-width: 310px;
  color: ${(p) => p.theme.greys.shade70};
  line-height: 21px;
  margin-top: 8px;
  font-size: ${fontSizes.medium};
`;

/*
 * Component.
 */

export const TableEmptyState: FC<TableEmptyStateProps> = (props) => {
  const {children, headerOffset, className} = props;

  return (
    <StyledEmptyStateContainerDiv className={className} $top={headerOffset}>
      <StyledEmptyStateContentsContainerDiv>
        <StyledEmptyStateDescriptionDiv>{children}</StyledEmptyStateDescriptionDiv>
      </StyledEmptyStateContentsContainerDiv>
    </StyledEmptyStateContainerDiv>
  );
};
